import axios from "shared/api/axiosConfig";
import { encryptApiBodyFromJSON, decryptApiBodyToJson } from "shared/api/cryptApiBody";
import apiInstance from "shared/api/axiosConfig";

// Base URL (via .env)
export const baseURL  = apiInstance.getUri() || "http://localhost:8082";

// Envoi du formulaire (texte + fichiers)
export async function accompanimentSendMail(payload) {
  try {
    const fd = new FormData();
    fd.append("firstName", payload.firstName);
    fd.append("lastName",  payload.lastName);
    fd.append("address",   payload.address);
    fd.append("phone",     payload.phone);

    if (payload.incidentDate){fd.append("incidentDate", payload.incidentDate);}
    
    if (payload.comment)      fd.append("comment", payload.comment);
    if (payload.identityDocument) fd.append("identityDocument", payload.identityDocument);
    if (payload.policeReport)  { console.log("test incident date");
     fd.append("policeReport", payload.policeReport);
    }

    // IMPORTANT: on NE fixe PAS le header Content-Type ici (Axios gère le boundary)
    const res = await axios.post("/accompaniment/mail", fd,{headers:{"Content-Type":"multipart/form-data"}});
    return res?.data ?? { success: true, message: "Demande envoyée." };
  } catch (error) {
    if (error?.response) {
      const s = error.response.status;
      const m = error.response.data?.message;
      if (s === 400 || s === 422) throw new Error(m || "Données invalides.");
      if (s === 500) throw new Error(m || "Erreur interne serveur.");
    }
    throw new Error("Impossible de contacter le serveur.");
  }
}

export async function accompanimentPing() {
  try {
    const res = await fetch(`${baseURL}/accompaniment/ping`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ encrypt: encryptApiBodyFromJSON({ ping: "accompaniment" }) }),
    });
    const data = await res.json();
    try { return decryptApiBodyToJson(data); } catch { return data; }
  } catch (e) {
    return { success: false, message: e?.message || "Erreur de ping." };
  }
}

export const ALLOWED_FILE_TYPES = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
export const MAX_FILE_SIZE = 10 * 1024 * 1024;

export function validateLocalFile(file) {
  if (!file) return { ok: false, error: "Aucun fichier" };
  if (!ALLOWED_FILE_TYPES.includes(file.type)) return { ok: false, error: "Type non autorisé (.jpeg,.jpg,.png,.pdf)" };
  if (file.size > MAX_FILE_SIZE) return { ok: false, error: "Fichier trop volumineux (max 10 Mo)" };
  return { ok: true, error: null };
}

/*const AccompanimentAPI = {
  accompanimentSendMail,
  accompanimentPing,
  validateLocalFile,
  ALLOWED_FILE_TYPES,
  MAX_FILE_SIZE,
  baseURL,
};*/

// export default { accompanimentSendMail, accompanimentPing, baseURL };

